import React, { useContext, useEffect, useMemo } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { GraphUp, Person, Image, FileText, ChevronLeft, ChevronRight } from 'react-bootstrap-icons'
import { observer } from 'mobx-react-lite'
import SidebarLinks from '../../ProjectManager/Campaign/CampaignPageParts/SIdebarParts/SidebarLinks'
import { SharedInfluencerContext } from '../../../contexts/Advertiser/SharedInfluencerContext'
import SectionTitle from '../../ProjectManager/Campaign/CampaignPageParts/SIdebarParts/SectionTitle'
import { useSidebarCollapse } from '../../../contexts/SidebarCollapseContext'

export default observer(function SharedInfluencerSidebar() {
  const { influencerState } = useContext(SharedInfluencerContext)
  const location = useLocation()
  const { uuid } = useParams()
  const { isCollapsed, toggleCollapse } = useSidebarCollapse()

  const selectedAuthentication = useMemo(() => influencerState?.authentication, [influencerState?.authentication?.id])

  const paths = {
    overview: 'overview',
    statistics: 'statistics',
    social_posts: 'social_posts',
    similar_influencers: 'similar_influencers',
    ratings: 'ratings',
    manage: 'manage',
    collaborations: 'collaborations',
  }

  const computedActivePath = useMemo(() => {
    const pathname = location.pathname
    const sortedPaths = Object.keys(paths).sort((a, b) => b.length - a.length)

    for (const path of sortedPaths) {
      const pathPattern = `/${path}`
      if (pathname.includes(pathPattern) || pathname.endsWith(`/${path}`)) {
        return paths[path] || path
      }
    }

    return 'overview'
  }, [location.pathname])

  useEffect(() => {
    document.getElementById(Object.keys(paths).find(key => paths[key] === computedActivePath))?.scrollIntoView({ behavior: 'smooth', block: 'start' })
  }, [computedActivePath])

  return (
    <div className={`fixed ${isCollapsed ? 'w-16' : 'w-56'} bg-white dark:bg-rb-dark-mode border-r-1 dark:border-rb-dark-mode-lighter pt-16 h-full transition-all duration-300 z-10`}>
      {!isCollapsed && (
        <div className="px-4 flex items-center justify-between">
          <p className="text-xs text-gray-300 dark:text-gray-400 uppercase">Influencer details</p>
          <button
            onClick={toggleCollapse}
            className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white"
            title="Összecsukás"
          >
            <ChevronLeft className="text-sm" />
          </button>
        </div>
      )}
      {isCollapsed && (
        <div className="px-2 flex items-center justify-center py-2">
          <button
            onClick={toggleCollapse}
            className="p-1 rounded-md hover:bg-gray-200 dark:hover:bg-rb-dark-mode-lighter dark:text-white"
            title="Kinyitás"
          >
            <ChevronRight className="text-sm" />
          </button>
        </div>
      )}
      <SidebarLinks text="Overview" icon={<Person />} link={`/advertiser/influencers/shared/${uuid}/overview`} active={computedActivePath === 'overview'} />
      <SidebarLinks text="Statistics" icon={<GraphUp />} link={`/advertiser/influencers/shared/${uuid}/statistics`} active={computedActivePath === 'statistics'} />
      <SidebarLinks text="Social Posts" icon={<Image />} link={`/advertiser/influencers/shared/${uuid}/social_posts`} active={computedActivePath === 'social_posts'} />
      <SidebarLinks text="Collaborations" icon={<FileText />} link={`/advertiser/influencers/shared/${uuid}/collaborations`} active={computedActivePath === 'collaborations'} />
    </div>
  )
})
